import styled from 'styled-components'
import { legalDocumentTypography } from 'styles/legalDocument'
import { MAX_PAGE_WIDTH } from 'utils/constants'

export const Container = styled.div`
  width: 100%;
  max-width: ${MAX_PAGE_WIDTH};
  padding: 0 12px;
  margin-bottom: 3rem;

  ${legalDocumentTypography}
`
